import { apiCallPost } from "../api"
import { apiPaths } from "../config/apiPaths";

export const getCompanyInfoApi = async (inputData, authHeaders) => {
    const apiInputData = {
        ...inputData,
    };
    try {
        const res = await apiCallPost(apiPaths.companyInfo, apiInputData, authHeaders);
        if (res) {
            return { data: res, status: true };
        }
        return { data: {}, status: false, errMsg: 'Failed to fetch company info' };
    } catch (err) {
        return { status: false, errMsg: err.message };
    }
}
